// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={97}
    height={92}
    viewBox="0 0 97 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M68.1269 22.2482L15.2788 51.3594L34.5081 86.268L87.3562 57.1568L68.1269 22.2482Z"
      fill="#FFD074"
      stroke="#29292F"
      strokeWidth={0.78201}
      strokeLinejoin="round"
    />
    <path
      d="M15.2786 51.3594L28.0723 13.294C28.1792 12.9206 28.3589 12.5719 28.6011 12.2682C28.8433 11.9645 29.1431 11.7116 29.4834 11.5242C29.8236 11.3368 30.1976 11.2185 30.5837 11.1761C30.9698 11.1337 31.3606 11.1681 31.7334 11.2773L68.1266 22.2482L15.2786 51.3594Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeWidth={0.78201}
      strokeLinejoin="round"
    />
    <path
      d="M58.8215 11.4363L11.52 37.4922L18.2558 49.7203L65.5573 23.6644L58.8215 11.4363Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeWidth={0.78201}
      strokeLinejoin="round"
    />
    <path
      d="M67.8887 11.2428L67.9894 11.3863C68.8447 10.8846 69.7909 10.5571 70.7735 10.4229C71.756 10.2886 72.7554 10.3503 73.7137 10.6042C74.672 10.8582 75.5703 11.2995 76.3567 11.9025C77.143 12.5055 77.8018 13.2584 78.2949 14.1175L78.385 14.075C77.8842 13.2236 77.558 12.2811 77.4253 11.3024C77.2927 10.3236 77.3562 9.32818 77.6123 8.37397C77.8683 7.41977 78.3118 6.52585 78.9168 5.74425C79.5218 4.96264 80.2763 4.30896 81.1364 3.82123L81.0917 3.75729C77.5085 5.81817 73.3728 5.13648 71.0218 1.05448L70.7949 1.15897C72.375 4.67017 71.3008 9.28031 67.8887 11.2428Z"
      fill="#FCFBF7"
      stroke="#37363F"
      strokeWidth={0.78201}
    />
    <path
      d="M1.18035 62.76L1.24513 62.8828C1.967 62.574 2.74294 62.4112 3.5281 62.4038C4.31325 62.3964 5.09204 62.5445 5.81944 62.8396C6.54683 63.1347 7.2084 63.5709 7.76588 64.1231C8.32336 64.6752 8.76571 65.3322 9.06733 66.0563L9.14229 66.0319C8.8339 65.3131 8.67171 64.5403 8.66517 63.7583C8.65862 62.9763 8.80785 62.2007 9.10417 61.4768C9.40049 60.7528 9.83799 60.0949 10.3912 59.5414C10.9444 58.9878 11.6023 58.5496 12.3265 58.2524L12.2978 58.1977C9.27765 59.4589 6.09717 58.5108 4.65781 55.07L4.46916 55.1294C5.35997 58.045 4.0563 61.559 1.18035 62.76Z"
      fill="#FCFBF7"
      stroke="#37363F"
      strokeWidth={0.78201}
    />
    <path
      d="M58.0046 69.4836L58.0361 69.6561C59.0228 69.5581 60.0193 69.6564 60.968 69.9454C61.9166 70.2344 62.7986 70.7083 63.5628 71.3398C64.3271 71.9713 64.9585 72.7479 65.4205 73.6245C65.8826 74.5012 66.1661 75.4605 66.2547 76.4472L66.3543 76.4462C66.2555 75.4634 66.3534 74.4709 66.6423 73.5263C66.9311 72.5818 67.4052 71.7042 68.0368 70.9446C68.6685 70.1849 69.4451 69.5584 70.3216 69.1015C71.1981 68.6446 72.1568 68.3664 73.1421 68.2831L73.1282 68.2063C69.0115 68.5796 65.54 66.2307 65.1117 61.5396L64.8619 61.5396C64.8287 65.3898 61.9248 69.1281 58.0046 69.4836Z"
      fill="#FCFBF7"
      stroke="#37363F"
      strokeWidth={0.78201}
    />
  </svg>
);
const SvgEmail = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgEmail;
